import React, { useState} from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { CssBaseline, Box, AppBar, Toolbar, DialogTitle, Dialog, Typography, DialogActions, DialogContent, IconButton, Switch, ThemeProvider, createTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, CircularProgress, Collapse } from '@mui/material';
import {FaChalkboardTeacher, FaChalkboard, FaBookReader, FaBook, FaMoneyBill, FaGraduationCap, FaSchool, FaReceipt, FaPagelines, FaCashRegister, FaIdCard} from "react-icons/fa";

import HomeIcon from '@mui/icons-material/Home';

import { ExpandLess, ExpandMore } from "@mui/icons-material";

import "./headerSidenav.css";
import {TextField,Button, Modal,Fade,Backdrop} from "@mui/material";
import SubjectFormModal from './Class/Subjects/SubjectFormModal';


const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [divisions, setDivisions] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    division: "",
  });
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
 
    setTimeout(async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
  
        await axios.post(
          "http://127.0.0.1:8000/api/users/grade-classes/",
          formData,
          config
        );
  
        Swal.fire({
          icon: "success",
          title: "Class Added Successfully",
          text: "Thank you",
          timer: 2000,
          showConfirmButton: false,
        });
  
        setFormData({ name: "", division: "" }); 
        setOpen(false); 
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message || "Failed to add class",
        });
      } finally {
        setLoading(false);
      }
    }, 3000); 
  };

//divission
  const handleeClickOpen = () => {
    setOopen(true);
};

const handleCcclose = () => {
    setOopen(false);
    setName('');
    setLoading(false);
};



const token = localStorage.getItem("access");

const handleSuubmit = (event) => {
  event.preventDefault();
  setLoading(true);
  if (!token) return;

 

  setTimeout(async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const response = await axios.post(
        "http://127.0.0.1:8000/api/users/divisions/",
        { name },
        config
      );

      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Division Created",
          text: "The division was successfully added!",
          timer: 2000,
          showConfirmButton: false,
        });
        handleCcclose();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.name || "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  }, 3000); // 3-second delay before making the API call
};


  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const theme = createTheme({
    // palette: {
    //   mode: darkMode ? 'dark' : 'light',
    // },
  });



  // const toggleDarkMode = () => setDarkMode(!darkMode);
  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const handleOopen = () => setModalOpen(true);
  const handleCclose = () => setModalOpen(false);
  const [oopen, setOopen] = useState(false);
  const [name, setName] = useState('');
  // const [loading, setLoading] = useState(false);

  const refreshSubjectList = () => {
      console.log('Subject list refreshed!');
  };

  const [openGradesMenu, setOpenGradesMenu] = useState(false);

  const handleGradesClick = () => {
    setOpenGradesMenu(!openGradesMenu);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        {/* AppBar */}
        <AppBar position="fixed" sx={{ zIndex: theme.zIndex.drawer + 1 }} style={{ backgroundColor: "#2b466e", color: "#ffffff" }}>
          <Toolbar>
            <IconButton
              color="inherit"
              edge="start"
              onClick={toggleDrawer}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              Admin Dashboard
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <div className='addedfunction'>
            <div className='chalkboardteacherdiv'>
              <FaChalkboardTeacher title="Add Class" className='addclass' onClick={handleOpen} />
             </div>
             <div className='chalkboardteacherdiv'>
              <FaBook title="Add Subject" className='addclass' onClick={handleOopen} />
             </div>
             <div className='chalkboardteacherdiv'>
              <FaSchool title="Create Division" className='addclass' onClick={handleeClickOpen} />
             </div>
            </div>
          
            </Toolbar>
        </AppBar>

        {/* Drawer */}
        <Drawer
  variant="persistent"
  open={drawerOpen}
  onClose={toggleDrawer}
  sx={{
    '& .MuiDrawer-paper': {
      width: 240,
      backgroundColor: '#0D1B2A',
      boxSizing: 'border-box',
      overflowY: 'auto', 
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#2b466e',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#FFA500',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#ffcc80',
      },
    },
  }}
>
      <Toolbar />
      <List>
        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/admin-dashboard">
          <ListItemIcon style={{ color: "#FFA500" }}><HomeIcon /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Home" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/studentsAdmission">
          <ListItemIcon style={{ color: "#FFA500" }}><FaGraduationCap /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Students Admission" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/financialPaymentRecord">
          <ListItemIcon style={{ color: "#FFA500" }}><FaMoneyBill /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="School Fees Record" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/receiptPayment">
          <ListItemIcon style={{ color: "#FFA500" }}><FaReceipt /></ListItemIcon>
          <ListItemText style={{ color: "#FFFFFF" }} primary="Student Receipt" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/adminPublishGrades">
          <ListItemIcon style={{ color: "#FFA500" }}><FaReceipt /></ListItemIcon>
          <ListItemText style={{ color: "#FFFFFF" }} primary="Publish Grades" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/paymentList">
          <ListItemIcon style={{ color: "#FFA500" }}><FaReceipt /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Receipt Records" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/classViewList">
          <ListItemIcon style={{ color: "#FFA500" }}><FaChalkboard /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Classroom List" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/subjectViewList">
          <ListItemIcon style={{ color: "#FFA500" }}><FaBookReader /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Subject List" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/divisionList">
          <ListItemIcon style={{ color: "#FFA500" }}><FaSchool /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }}  style={{ color: "#FFFFFF" }} primary="Divisions" />
        </ListItem>

        {/* Dropdown Menu for Grades */}
        <ListItem button onClick={handleGradesClick} sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }}>
          <ListItemIcon style={{ color: "#FFA500" }}><FaPagelines /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Grades Reports" />
          {openGradesMenu ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        
        <Collapse in={openGradesMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem button sx={{ color: "white", pl: 4, "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/gradeDistribution">
              <ListItemIcon style={{ color: "#FFA500" }}><FaPagelines /></ListItemIcon>
              <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Grade Distribution" />
            </ListItem>

            <ListItem button sx={{ color: "white", pl: 4, "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/periodReport">
              <ListItemIcon style={{ color: "#FFA500" }}><FaCashRegister /></ListItemIcon>
              <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Periodic Grades" />
            </ListItem>

            <ListItem button sx={{ color: "white", pl: 4, "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/reportCard">
              <ListItemIcon style={{ color: "#FFA500" }}><FaIdCard /></ListItemIcon>
              <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Report Cards" />
            </ListItem>
          </List>
        </Collapse>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/teacherDataForm">
          <ListItemIcon style={{ color: "#FFA500" }}><FaChalkboardTeacher /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Teachers Data" />
        </ListItem>

          <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/attendanceRecord">
          <ListItemIcon style={{ color: "#FFA500" }}><FaChalkboardTeacher /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Students Attendance" />
        </ListItem>

        <ListItem button sx={{ color: "white", "&:hover": { backgroundColor: "#2b466e" } }} component={Link} to="/attendanceData">
          <ListItemIcon style={{ color: "#FFA500" }}><FaChalkboardTeacher /></ListItemIcon>
          <ListItemText sx={{ "& .MuiTypography-root": { fontSize: "0.875rem" } }} style={{ color: "#FFFFFF" }} primary="Attendance Data" />
        </ListItem>
      </List>
    </Drawer>
        
     
      </Box>
      <div className='addclassroom'>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Add Grade Class
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                margin="normal"
                label="Class Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <TextField
                fullWidth
                margin="normal"
                label="Division"
                name="division"
                value={formData.division}
                onChange={handleChange}
                required
              />
       
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                // disabled={loading}
              >
              {loading ? <CircularProgress size={24} style={{ color: '#FFF9C4' }} /> : "Submit"}
              </Button>
              </Box>
          </Box>
        </Fade>
      </Modal>

      <div className='subject'>
      <Box sx={{ textAlign: 'center', marginTop: 4 }}>
   
            <SubjectFormModal
                open={modalOpen}
                handleClose={handleCclose}
                onSubjectCreated={refreshSubjectList}
            />
        </Box>
      </div>
    </div>

    <div>
      
            <Dialog open={oopen} onClose={handleCcclose}>
                <DialogTitle>Add a New Division</DialogTitle>
                <form onSubmit={handleSuubmit}>
                    <DialogContent>
                        {loading ? (
                            <Box justifyContent="center" alignItems="center" height="100%">
                              <p>Please wait a moment...</p> 
                               <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                               <CircularProgress />
                               </Box>
                            </Box>
                        ) : (
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Division Name"
                                type="text"
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        )}
                    </DialogContent>
                    <DialogActions>
                        {!loading && (
                            <>
                                <Button onClick={handleClose} color="secondary">
                                    Cancel
                                </Button>
                                <Button type="submit" color="primary">
                                    Submit
                                </Button>
                            </>
                        )}
                    </DialogActions>
                </form>
            </Dialog>
        </div>

    </ThemeProvider>
  );
};

export default Header;

